import { getRoot } from 'mobx-state-tree';
import { GMAIL_BASE_URL } from '../../../HOCs/withLushaApp/constants';
import { isVersionGreaterThen } from '../../../utils/comparePluginVersion';
import { getType } from '../../Context/Actions/helpers';
import { PAGE_TYPES } from '../../Context/constants';
import { APPS, HUBSPOT_PLATFORMS, LINKEDIN_PLATFORMS, LINKEDIN_RECRUITER_PLATFORMS, PLATFORMS, SALESFORCE_PLATFORMS, } from '../constants';
// August 15th, 2022
const PERMISSIONS_BANNER_LAUNCH_DATE = new Date(1660521600000);
const PERMISSIONS_BANNER_MIN_VERSION = '10.3.15';
export const SettingsViews = self => ({
    get app() {
        const { context } = getRoot(self);
        let { type } = context;
        const isGmail = self.initialUrl.includes(GMAIL_BASE_URL);
        if (type === PAGE_TYPES.UNKNOWN && self.initialUrl && !context.url) {
            type = getType({ url: self.initialUrl, corePluginVersion: self.externalPluginVersion });
        }
        if (type === PAGE_TYPES.BULK) {
            switch (self.platform) {
                case '':
                    return null;
                case PLATFORMS.LINKEDIN_SALES_NAVIGATOR:
                case PLATFORMS.LINKEDIN:
                case PLATFORMS.LINKEDIN_RECRUITER_LITE:
                case PLATFORMS.LINKEDIN_RECRUITER_PRO:
                    return APPS.BULK;
                default:
                    return APPS.SCOUT;
            }
        }
        switch (self.platform) {
            case '':
                return null;
            case PLATFORMS.LINKEDIN_SALES_NAVIGATOR:
            case PLATFORMS.LINKEDIN_RECRUITER_LITE:
            case PLATFORMS.LINKEDIN_RECRUITER_PRO:
            case PLATFORMS.LINKEDIN:
            case PLATFORMS.LINKEDIN_PUBLIC:
            case PLATFORMS.SALESFORCE_CLASSIC:
            case PLATFORMS.SALESFORCE_LIGHTNING:
            case PLATFORMS.HUBSPOT:
                if (context.isCompanyPage) {
                    return APPS.SCOUT;
                }
                return APPS.CONTACTS;
            default: {
                return isGmail ? APPS.SEARCH_TAB : APPS.SCOUT;
            }
        }
    },
    get isFooterMenuDisabled() {
        return !self.isPrivacyApproved;
    },
    get isSalesforcePlatform() {
        return SALESFORCE_PLATFORMS.includes(self.platform);
    },
    get isLinkedinPlatform() {
        return LINKEDIN_PLATFORMS.includes(self.platform);
    },
    get isHubspotPlatform() {
        return HUBSPOT_PLATFORMS.includes(self.platform);
    },
    get isLinkedinRecruiter() {
        return LINKEDIN_RECRUITER_PLATFORMS.includes(self.platform);
    },
    get isPlatformIncludesSubViews() {
        return self.platform === PLATFORMS.LINKEDIN;
    },
    get showPermissionsRequestBanner() {
        const { user: { analytics: { registerDate } } } = getRoot(self);
        const userRegisteredBeforeBannerLaunchDate = registerDate < PERMISSIONS_BANNER_LAUNCH_DATE;
        const hasMinimumPluginVersion = isVersionGreaterThen(self.externalPluginVersion, PERMISSIONS_BANNER_MIN_VERSION);
        return userRegisteredBeforeBannerLaunchDate && hasMinimumPluginVersion;
    },
    get isScoutPlatform() {
        return self.platform === PLATFORMS.SCOUT;
    },
});
